import StartEventHook from './StartEventHook'
import { bidderForCode } from '../utils'
import FillManager from '../FillManager'
import { DistroScaleFillMethod } from '../fillers/DistroScaleFillMethod'

export default class AvantisHook extends StartEventHook {
  constructor () {
    super('DistroScaleStartHook')
  }

  async run (remoteConfig) {
    const bidder = bidderForCode('distroscale', remoteConfig.bidders(), true)
    if (!bidder) return

    FillManager.register(new DistroScaleFillMethod(bidder))
  }
}
